import { Component, Prop, h, State, Element, Host } from '@stencil/core';
import { arrow_right } from 'pn-design-assets/pn-assets/icons.js';
@Component({
  tag: 'pn-profile-selector-option',
  styleUrl: 'pn-profile-selector-option.scss',
})
export class PnProfileSelectorOption {
  @Element() hostElement: Element;

  @Prop() heading: string = '';
  @Prop() description: string = '';
  @Prop() url: string = '';

  render() {
    return (
      <Host>
        <a class="profileselectoroption" href={this.url}>
          <span class="profileselectoroption-text">
            <span class="profileselectoroption-title">{this.heading}</span>
            <span class="profileselectoroption-description">{this.description}</span>
          </span>
          <pn-icon icon={arrow_right} small="false" color="blue700"></pn-icon>
        </a>
      </Host>
    );
  }
}
